var installedModules = {};
var moduleToHandlerMapping = {
	0: {
		getter: () => (() => (__webpack_require__(1448))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "16.14.0",
			  "strictVersion": true,
			  "singleton": false,
			  "eager": true
			},
			scope: ["default"],
		},
		shareKey: "react",
	},
	20: {
		getter: () => (() => (__webpack_require__(2665))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "16.14.0",
			  "strictVersion": false,
			  "singleton": true,
			  "eager": true
			},
			scope: ["default"],
		},
		shareKey: "react-dom",
	},
	3750: {
		getter: () => (() => (__webpack_require__(1049))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "4.17.21",
			  "strictVersion": false,
			  "singleton": true,
			  "eager": true
			},
			scope: ["default"],
		},
		shareKey: "lodash",
	},
	4036: {
		getter: () => (() => (__webpack_require__(2670))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "16.14.0",
			  "strictVersion": true,
			  "singleton": false,
			  "eager": true
			},
			scope: ["default"],
		},
		shareKey: "react",
	},
	4141: {
		getter: () => (() => (__webpack_require__(2650))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "2.20.40",
			  "strictVersion": false,
			  "singleton": true,
			  "eager": true
			},
			scope: ["default"],
		},
		shareKey: "glamor",
	},
	4144: {
		getter: () => (() => (__webpack_require__(2666))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "5.1.0",
			  "strictVersion": false,
			  "singleton": true,
			  "eager": true
			},
			scope: ["default"],
		},
		shareKey: "react-redux",
	},
	4155: {
		getter: () => (() => (__webpack_require__(2667))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "3.0.5",
			  "strictVersion": false,
			  "singleton": true,
			  "eager": true
			},
			scope: ["default"],
		},
		shareKey: "react-router",
	},
	4164: {
		getter: () => (() => (__webpack_require__(2651))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "^3.1.0",
			  "strictVersion": false,
			  "singleton": true,
			  "eager": true
			},
			scope: ["default"],
		},
		shareKey: "launchdarkly-react-client-sdk",
	},
	4574: {
		getter: () => (() => (__webpack_require__(2652))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "npm:react-dnd@^11.1.3",
			  "strictVersion": false,
			  "singleton": true,
			  "eager": true
			},
			scope: ["default"],
		},
		shareKey: "react-dnd-latest",
	}
};
var initialConsumes = [0];
__webpack_require__.federation.installInitialConsumes = () => (__webpack_require__.federation.bundlerRuntime.installInitialConsumes({
	initialConsumes: initialConsumes,
	installedModules:installedModules,
	moduleToHandlerMapping:moduleToHandlerMapping,
	webpackRequire: __webpack_require__
}))
var chunkMapping = {
	"2": [
		0
	],
	"3": [
		20,
		3750,
		4036,
		4141,
		4144,
		4155,
		4164,
		4574
	]
};
__webpack_require__.f.consumes = (chunkId, promises) => {
	__webpack_require__.federation.bundlerRuntime.consumes({
	chunkMapping: chunkMapping,
	installedModules: installedModules,
	chunkId: chunkId,
	moduleToHandlerMapping: moduleToHandlerMapping,
	promises: promises,
	webpackRequire:__webpack_require__
	});
}